import apiClient from '../index';

export const getParentProfile = async () => {
  try {
    const response = await apiClient.get('/api/parent/profile');

    // Validate response structure
    if (!response.data) {
      throw new Error('Invalid response format - no data received');
    }

    return response.data;
  } catch (error) {
    // Enhanced error logging with request details
    console.error('Error fetching parent profile:', {
      status: error.response?.status,
      message: error.response?.data?.message || error.message,
      path: '/api/parent/profile',
    });

    if (error.response?.status === 401) {
      return null;
      // throw new Error('Authentication required - please log in');
    }
    if (error.response?.status === 500) {
      throw new Error(
        'Server error while fetching parent profile. Please try again later.'
      );
    }
    throw error;
  }
};

export const getParents = async () => {
  try {
    const response = await apiClient.get('/api/parent/');
    console.log('Raw getParents response:', response);

    // Extract data properly from { message: 'Successful', data: [...parents] } structure
    const parentsData = response.data?.data;

    if (!parentsData) {
      console.error('Parents data not found in response:', response.data);
      return [];
    }

    if (Array.isArray(parentsData)) {
      return parentsData.map((parent) => {
        // Extract names from raw data
        const firstName = parent.firstName || '';
        const lastName = parent.lastName || '';

        return {
          id: parent.parentId || parent.id,
          parentId: parent.parentId || parent.id,
          firstName,
          lastName,
          name: `${firstName} ${lastName}`.trim(),
          email: parent.email || '',
          phone: parent.phoneNumber || '',
          phoneNumber: parent.phoneNumber || '',
          address: parent.address || '',
          children: parent.children || [],
          isActive: parent.status === 'active',
          status: parent.status || 'inactive',
          registeredDate: parent.createdAt || new Date().toISOString(),
          photoUrl: parent.photoUrl || '/placeholder.svg',
          avatar: parent.photoUrl || '/placeholder.svg',
        };
      });
    }
    return [];
  } catch (error) {
    console.error('Error fetching parents:', error);
    throw error;
  }
};

export const getParentById = async (id) => {
  try {
    const response = await apiClient.get(`/api/parent/${id}`);
    const parentData = response.data?.data;

    if (!parentData) {
      console.error('Parent data not found in response:', response.data);
      throw new Error('Parent data not found');
    }

    // Extract names from raw data
    const firstName = parentData.firstName || '';
    const lastName = parentData.lastName || '';

    return {
      id: parentData.parentId || parentData.id,
      parentId: parentData.parentId || parentData.id,
      firstName,
      lastName,
      name: `${firstName} ${lastName}`.trim(),
      email: parentData.email || '',
      phone: parentData.phoneNumber || '',
      phoneNumber: parentData.phoneNumber || '',
      address: parentData.address || '',
      children: parentData.children || [],
      isActive: parentData.status === 'active',
      status: parentData.status || 'inactive',
      registeredDate: parentData.createdAt || new Date().toISOString(),
      photoUrl: parentData.photoUrl || '/placeholder.svg',
      avatar: parentData.photoUrl || '/placeholder.svg',
    };
  } catch (error) {
    console.error(`Error fetching parent with id ${id}:`, error);
    throw error;
  }
};

export const createParent = async (ParentData) => {
  try {
    const response = await apiClient.post('/api/parent/', ParentData);
    return response.data;
  } catch (error) {
    console.error('Error creating parent: ', error);
    throw error;
  }
};

export const updateParent = async (id, ParentData) => {
  try {
    const response = await apiClient.put(`/api/parent/${id}`, ParentData);
    return response.data;
  } catch (error) {
    console.error(`Error updating parent with id ${id}:`, error);
    throw error;
  }
};

export const deleteParent = async (id) => {
  try {
    const response = await apiClient.delete(`/api/parent/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting parent with id ${id}:`, error);
    throw error;
  }
};

export const parentLogin = async (body) => {
  try {
    const response = await apiClient.post(`/api/parent/login`, body);
    return response.data;
  } catch (error) {
    console.error(`Error on parent login`, error);
    throw error;
  }
};

export const parentLogout = async () => {
  try {
    const response = await apiClient.post(`/api/parent/logout`);
    return response.data;
  } catch (error) {
    console.error(`Error on parent logout`, error);
    throw error;
  }
};

export const parentVerifyOtp = async (otp) => {
  try {
    const response = await apiClient.post(`/api/parent/verifyemail`, { otp });
    return response.data;
  } catch (error) {
    console.error(`Error on parent verify otp`, error);
    throw error;
  }
};

export const parentResendOtp = async () => {
  try {
    const response = await apiClient.post(`/api/parent/sendemailotp`);
    return response.data;
  } catch (error) {
    console.error(`Error on parent resend otp`, error);
    throw error;
  }
};

export const parentSendEmailChangeOtp = async (newEmail) => {
  try {
    const response = await apiClient.post(`/api/parent/email/sendchangeotp`, {
      newEmail,
    });
    return response.data;
  } catch (error) {
    console.error(`Error on parent send email change otp`, error);
    throw error;
  }
};

export const parentChangeEmail = async (data) => {
  try {
    const response = await apiClient.put(`/api/parent/email/changemail`, data);
    return response.data;
  } catch (error) {
    console.error(`Error on parent change email`, error);
    throw error;
  }
};
